(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-image-fade"] && !Shopify.designMode) return;
  try {
    (function () {
    function mark(img) {
      img.classList.add('is-loaded');
    }

    // Capture-phase delegation ('load' doesn't bubble) so images appended
    // later — e.g. by the shop page's load-more fetch — are covered too.
    document.addEventListener('load', function (event) {
      const img = event.target;
      if (img instanceof HTMLImageElement && img.matches('.collection-page .image > img')) {
        mark(img);
      }
    }, true);

    // Images already loaded before this script ran never fire 'load' again.
    document.querySelectorAll('.collection-page .image > img').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        mark(img);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    const overlays = document.querySelectorAll('[data-countdown]');
    if (!overlays.length) return;

    overlays.forEach((overlay) => {
      const target = new Date(overlay.dataset.countdownTarget);
      if (Number.isNaN(target.getTime())) return;

      // On the shop page the whole page is locked: stop Lenis's virtual
      // scroll too (it initializes async from a deferred CDN script).
      const locksScroll = !!overlay.closest('.collection-page');
      if (locksScroll) {
        let tries = 0;
        const waitForLenis = setInterval(() => {
          if (window.lenis) {
            window.lenis.stop();
            clearInterval(waitForLenis);
          } else if (++tries > 50) {
            clearInterval(waitForLenis);
          }
        }, 100);
      }

      const days = overlay.querySelector('[data-countdown-days]');
      const hours = overlay.querySelector('[data-countdown-hours]');
      const mins = overlay.querySelector('[data-countdown-mins]');

      function tick() {
        const diff = target.getTime() - Date.now();

        if (diff <= 0) {
          clearInterval(interval);
          overlay.remove();
          if (locksScroll && window.lenis) window.lenis.start();
          return;
        }

        const totalMins = Math.floor(diff / 60000);
        const d = Math.floor(totalMins / 1440);
        const h = Math.floor((totalMins % 1440) / 60);
        const m = totalMins % 60;

        if (days) days.textContent = String(d);
        if (hours) hours.textContent = String(h).padStart(2, '0');
        if (mins) mins.textContent = String(m).padStart(2, '0');
      }

      const interval = setInterval(tick, 1000);
      tick();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["intro"] && !Shopify.designMode) return;
  try {
    (function () {
    var intro = document.querySelector('.intro');
    var counter = document.querySelector('.intro__counter');
    if (!intro || !counter) return;

    var STORAGE_KEY = 'introPlayed';
    var alreadyPlayed = false;
    try {
      alreadyPlayed = sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {}

    if (alreadyPlayed) {
      intro.parentNode && intro.parentNode.removeChild(intro);
      return;
    }

    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}

    document.documentElement.style.overflow = 'hidden';

    var current = 0;
    var target = 0;
    var pageReady = false;

    function format(n) {
      return String(Math.round(n)).padStart(2, '0') + '%';
    }

    function tick() {
      current += (target - current) * 0.12;
      if (target - current < 0.1) current = target;
      counter.textContent = format(current);

      if (current >= 100) {
        intro.classList.add('is-hidden');
        document.documentElement.style.overflow = '';
        setTimeout(function () {
          intro.parentNode && intro.parentNode.removeChild(intro);
        }, 700);
        return;
      }

      requestAnimationFrame(tick);
    }

    var fakeProgress = 0;
    var fakeInterval = setInterval(function () {
      fakeProgress = Math.min(fakeProgress + Math.random() * 12, pageReady ? 100 : 90);
      target = fakeProgress;
      if (fakeProgress >= 100) clearInterval(fakeInterval);
    }, 120);

    function onReady() {
      pageReady = true;
    }

    if (document.readyState === 'complete') {
      onReady();
    } else {
      window.addEventListener('load', onReady);
    }

    requestAnimationFrame(tick);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["popup"] && !Shopify.designMode) return;
  try {
    (function () {
    const popup = document.querySelector('[data-popup]');
    if (!popup) return;

    const STORAGE_KEY = 'newsletter-popup-dismissed';
    const posted = !!popup.querySelector('.popup__success');
    const dismissed = sessionStorage.getItem(STORAGE_KEY) === 'true';

    if (dismissed && !posted) return;

    setTimeout(() => {
      popup.classList.add('popup--visible');
    }, posted ? 400 : 3000);

    popup.querySelector('[data-popup-close]').addEventListener('click', () => {
      popup.classList.remove('popup--visible');
      sessionStorage.setItem(STORAGE_KEY, 'true');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
